import { TFunction } from 'i18next';
import { options } from '@common/components/Job/formFields/fields/VideoQuestions/options';
import {
  BrandName,
  SupportedCountryCode
} from '@seek/je-shared-data/lib/types/brand';

type Props = {
  t: TFunction;
  brand: BrandName;
  countryCode: SupportedCountryCode;
  params: Record<string, string>;
  videoQuestionCode: string;
};

export const getTranslatedVideoQuestion = ({
  t,
  brand,
  countryCode,
  params,
  videoQuestionCode
}: Props) => {
  const videoQuestionOptions = options({
    t,
    brand,
    countryCode,
    params
  }).find((option) => option.key === videoQuestionCode);

  return videoQuestionOptions?.label;
};
